import { NEARBY_SOCKET_EVENTS } from "../nearbyTransfer.constants";

export const parseNearbySocketMessage = (messageText) => {
  try {
    const message = JSON.parse(messageText);
    return typeof message?.type === "string" ? message : null;
  } catch (error) {
    return null;
  }
};

export const createPresenceJoinMessage = ({ deviceIdentity }) => ({
  type: NEARBY_SOCKET_EVENTS.PRESENCE_JOIN,
  deviceId: deviceIdentity.deviceId,
  deviceName: deviceIdentity.deviceName,
  clientVersion: "web-v1",
});

export const createPairRequestMessage = ({ requestId, targetDeviceId }) => ({
  type: NEARBY_SOCKET_EVENTS.PAIR_REQUEST,
  requestId,
  targetDeviceId,
});

export const createPairAcceptMessage = ({ requestId }) => ({
  type: NEARBY_SOCKET_EVENTS.PAIR_ACCEPT,
  requestId,
});

export const createPairDeclineMessage = ({ requestId }) => ({
  type: NEARBY_SOCKET_EVENTS.PAIR_DECLINE,
  requestId,
});

export const createWebRtcSignalMessage = ({
  sessionId,
  targetDeviceId,
  signal,
}) => ({
  type: NEARBY_SOCKET_EVENTS.WEBRTC_SIGNAL,
  sessionId,
  targetDeviceId,
  signal,
});
